import start from './start';
import navSlide from './navSlide';
import searchToggle from './searchToggle';
import stickyHeader from './stickyHeader';
import textExpand from './textExpand';
import accordion from './accordion';
import toc from './toc';
import handleBrokenImages from './brokenImages';
import sticky from './stickyModalInit';
import subMenuToggle from './subMenuToggle';

start();
navSlide();
searchToggle();
stickyHeader();
accordion();
toc();
textExpand();
handleBrokenImages();
subMenuToggle();
